module.exports = __webpack_public_path__ + "img/10.1b9eaf1c.jpg";